export default {
    title: "Order Submitted",
    header: "@:views.order.submitted.title",
    message: "Your order has been submitted. For updates, please check your email or the dashboard on the <a href='{url}'>Home</a> page.",
    messageOutOfStock: "Your order was placed <b>except</b> for the items listed below as they are out of stock. Please make different selections to order these items. For updates, please check your email or the dashboard on the <a href='{url}'>Home</a> page."
}